<template>
  <b-input-group size="sm">
    <b-input-group-prepend is-text>
      Aspect
    </b-input-group-prepend>
    <b-form-select 
      v-model="ap.aspect" 
      :options="aspecten" 
      size="sm"
    />

    <b-input-group-addon is-text>
      Prioriteit
    </b-input-group-addon>

    <b-input-group-append>
      <b-form-radio-group 
        v-model="ap.prioriteit" 
        :options="prioriteiten" 
        size="sm" 
        button-variant="outline-secondary" 
        text-field="value" 
        buttons
      />
    </b-input-group-append>
  </b-input-group>
</template>
<script>
export default {
    name: 'AspectPrioriteit',
    props: {
        ap: {
            type: Object,
            default: function() {
                return {
                    aspect: 1,
                    prioriteit: 1
                }
            }
        }
    },
    data() {
        return {
            aspecten: [
                {value:1,text:'Veiligheid/gezondheid',prioriteiten:[1,2,3]},
                {value:2,text:'Cultuurhistorische waarde',prioriteiten:[2,3,4]},
                {value:3,text:'Gebruik en bedrijfsproces',prioriteiten:[3,4,5]},
                {value:4,text:'Technische vervolgschade',prioriteiten:[4,5,6]},
                {value:5,text:'Toename klachtenonderhoud',prioriteiten:[5,6,7]},
                {value:6,text:'Beleving esthetica',prioriteiten:[7,8,9]},
                {value:7,text:'Duurzaamheid',prioriteiten:[6,7,8]}
            ]
        }
    },
    computed: {
        prioriteiten () {
            var selected = this.aspecten.filter((item) => item.value == this.ap.aspect)
            var range = 9
            console.dir(selected)
            if (selected.length === 1) {
                return [...Array(range)].map(function (n,int) { return { value: int+1, disabled: !selected[0].prioriteiten.includes(int+1) } })
            } else {
                return [...Array(range)].map(function (n,int) { return { value: int+1 } })
            }
        }
    },

}
</script>